(function () {
  'use strict';
  angular
    .module('frontendApp',
    ['ui.bootstrap',
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'toastr',
      'LocalStorageModule',
      'satellizer',
      'sap.imageloader',
      'angular-inview',
      'ngMap',
      'fox.scrollReveal',
      'angularSmoothscroll',
      'angular-loading-bar',
      'swipe',
      '720kb.socialshare'
    ]);

})();

'use strict';
angular
  .module('frontendApp')
  .factory('ContentService', function ($http, $rootScope, $log) {
    return {

      find: function (tabla, id) {
        $log.log('GETDATA PARAMS', tabla, id);
        return $http.post($rootScope.api + '/api/' + tabla + '/find/' + id, {});
      },

      getdata: function (tabla, params) {
        $log.log('GETDATA PARAMS', tabla, params);
        return $http.post($rootScope.api + '/api/' + tabla + '/getdata', params);
      },

      websearch: function (params) {
        $log.log('WEBSEARCH PARAMS', params);
        return $http.post($rootScope.api + '/api/websearch', params);
      },

      webcontent: function (state, params) {
        params['state'] = state;
        $log.log('WEBCONTENT PARAMS', params);
        return $http.post($rootScope.api + '/api/webcontent', params);
      },

      sendform: function (params) {
        return $http.post($rootScope.api + '/api/sendform', params);
      },
      update: function (tabla, id, params) {
        //parametros['token'] = $rootScope.tk;
        $log.log('update PARAMS', params);
        return $http.post($rootScope.api + '/api/' + tabla + '/update/' + id, params);
      },
      finPlace: function ( params) {
        $log.log('PARAMS', params);
        return $http.get('https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input='+params.input+'&inputtype='+params.inputtype+'&key='+params.key);
      }


    };
  });

/**
 * Created by FER-PC-WIN10 on 03/05/2016.
 */
(function () {
  'use strict';
  angular
    .module('frontendApp')
    .directive('renderHtml', function ($compile) {
      return function (scope, element, attrs) {
        scope.$watch(
          function (scope) {
            return scope.$eval(attrs.renderHtml);
          },
          function (value) {
            element.html(value);
            $compile(element.contents())(scope);
          }
        );
      };
    });
})();

/* -----------------------------------------------
 /* Author : Vincent Garreau  - vincentgarreau.com
 /* MIT license: http://opensource.org/licenses/MIT
 /* Demo / Generator : vincentgarreau.com/particles.js
 /* GitHub : github.com/VincentGarreau/particles.js
 /* How to use? : Check the GitHub README
 /* v2.0.0
 /* ----------------------------------------------- */
function hexToRgb(e) {
  var a = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  e = e.replace(a, function (e, a, t, i) {
    return a + a + t + t + i + i
  });
  var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16)} : null
}
function clamp(e, a, t) {
  return Math.min(Math.max(e, a), t)
}
function isInArray(e, a) {
  return a.indexOf(e) > -1
}
var pJS = function (e, a) {
  var t = document.querySelector("#" + e + " > .particles-js-canvas-el");
  this.pJS = {
    canvas: {el: t, w: t.offsetWidth, h: t.offsetHeight},
    particles: {
      number: {value: 400, density: {enable: !0, value_area: 800}},
      color: {value: "#fff"},
      shape: {
        type: "circle",
        stroke: {width: 0, color: "#ff0000"},
        polygon: {nb_sides: 5},
        image: {src: "", width: 100, height: 100}
      },
      opacity: {value: 1, random: !1, anim: {enable: !1, speed: 2, opacity_min: 0, sync: !1}},
      size: {value: 20, random: !1, anim: {enable: !1, speed: 20, size_min: 0, sync: !1}},
      line_linked: {enable: !0, distance: 100, color: "#fff", opacity: 1, width: 1},
      move: {
        enable: !0,
        speed: 2,
        direction: "none",
        random: !1,
        straight: !1,
        out_mode: "out",
        bounce: !1,
        attract: {enable: !1, rotateX: 3e3, rotateY: 3e3}
      },
      array: []
    },
    interactivity: {
      detect_on: "canvas",
      events: {onhover: {enable: !0, mode: "grab"}, onclick: {enable: !0, mode: "push"}, resize: !0},
      modes: {
        grab: {distance: 100, line_linked: {opacity: 1}},
        bubble: {distance: 200, size: 80, duration: .4},
        repulse: {distance: 200, duration: .4},
        push: {particles_nb: 4},
        remove: {particles_nb: 2}
      },
      mouse: {}
    },
    retina_detect: !1,
    fn: {interact: {}, modes: {}, vendors: {}},
    tmp: {}
  };
  var i = this.pJS;
  a && Object.deepExtend(i, a), i.tmp.obj = {
    size_value: i.particles.size.value,
    size_anim_speed: i.particles.size.anim.speed,
    move_speed: i.particles.move.speed,
    line_linked_distance: i.particles.line_linked.distance,
    line_linked_width: i.particles.line_linked.width,
    mode_grab_distance: i.interactivity.modes.grab.distance,
    mode_bubble_distance: i.interactivity.modes.bubble.distance,
    mode_bubble_size: i.interactivity.modes.bubble.size,
    mode_repulse_distance: i.interactivity.modes.repulse.distance
  }, i.fn.retinaInit = function () {
    i.retina_detect && window.devicePixelRatio > 1 ? (i.canvas.pxratio = window.devicePixelRatio, i.tmp.retina = !0) : (i.canvas.pxratio = 1, i.tmp.retina = !1), i.canvas.w = i.canvas.el.offsetWidth * i.canvas.pxratio, i.canvas.h = i.canvas.el.offsetHeight * i.canvas.pxratio, i.particles.size.value = i.tmp.obj.size_value * i.canvas.pxratio, i.particles.size.anim.speed = i.tmp.obj.size_anim_speed * i.canvas.pxratio, i.particles.move.speed = i.tmp.obj.move_speed * i.canvas.pxratio, i.particles.line_linked.distance = i.tmp.obj.line_linked_distance * i.canvas.pxratio, i.interactivity.modes.grab.distance = i.tmp.obj.mode_grab_distance * i.canvas.pxratio, i.interactivity.modes.bubble.distance = i.tmp.obj.mode_bubble_distance * i.canvas.pxratio, i.particles.line_linked.width = i.tmp.obj.line_linked_width * i.canvas.pxratio, i.interactivity.modes.bubble.size = i.tmp.obj.mode_bubble_size * i.canvas.pxratio, i.interactivity.modes.repulse.distance = i.tmp.obj.mode_repulse_distance * i.canvas.pxratio
  }, i.fn.canvasInit = function () {
    i.canvas.ctx = i.canvas.el.getContext("2d")
  }, i.fn.canvasSize = function () {
    i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i && i.interactivity.events.resize && window.addEventListener("resize", function () {
      i.canvas.w = i.canvas.el.offsetWidth, i.canvas.h = i.canvas.el.offsetHeight, i.tmp.retina && (i.canvas.w *= i.canvas.pxratio, i.canvas.h *= i.canvas.pxratio), i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i.particles.move.enable || (i.fn.particlesEmpty(), i.fn.particlesCreate(), i.fn.particlesDraw(), i.fn.vendors.densityAutoParticles()), i.fn.vendors.densityAutoParticles()
    })
  }, i.fn.canvasPaint = function () {
    i.canvas.ctx.fillRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.canvasClear = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.particle = function (e, a, t) {
    if (this.radius = (i.particles.size.random ? Math.random() : 1) * i.particles.size.value, i.particles.size.anim.enable && (this.size_status = !1, this.vs = i.particles.size.anim.speed / 100, i.particles.size.anim.sync || (this.vs = this.vs * Math.random())), this.x = t ? t.x : Math.random() * i.canvas.w, this.y = t ? t.y : Math.random() * i.canvas.h, this.x > i.canvas.w - 2 * this.radius ? this.x = this.x - this.radius : this.x < 2 * this.radius && (this.x = this.x + this.radius), this.y > i.canvas.h - 2 * this.radius ? this.y = this.y - this.radius : this.y < 2 * this.radius && (this.y = this.y + this.radius), i.particles.move.bounce && i.fn.vendors.checkOverlap(this, t), this.color = {}, "object" == typeof e.value)if (e.value instanceof Array) {
      var s = e.value[Math.floor(Math.random() * i.particles.color.value.length)];
      this.color.rgb = hexToRgb(s)
    } else void 0 != e.value.r && void 0 != e.value.g && void 0 != e.value.b && (this.color.rgb = {
      r: e.value.r,
      g: e.value.g,
      b: e.value.b
    }), void 0 != e.value.h && void 0 != e.value.s && void 0 != e.value.l && (this.color.hsl = {
      h: e.value.h,
      s: e.value.s,
      l: e.value.l
    }); else"random" == e.value ? this.color.rgb = {
      r: Math.floor(256 * Math.random()) + 0,
      g: Math.floor(256 * Math.random()) + 0,
      b: Math.floor(256 * Math.random()) + 0
    } : "string" == typeof e.value && (this.color = e, this.color.rgb = hexToRgb(this.color.value));
    this.opacity = (i.particles.opacity.random ? Math.random() : 1) * i.particles.opacity.value, i.particles.opacity.anim.enable && (this.opacity_status = !1, this.vo = i.particles.opacity.anim.speed / 100, i.particles.opacity.anim.sync || (this.vo = this.vo * Math.random()));
    var n = {};
    switch (i.particles.move.direction) {
      case"top":
        n = {x: 0, y: -1};
        break;
      case"top-right":
        n = {x: .5, y: -.5};
        break;
      case"right":
        n = {x: 1, y: -0};
        break;
      case"bottom-right":
        n = {x: .5, y: .5};
        break;
      case"bottom":
        n = {x: 0, y: 1};
        break;
      case"bottom-left":
        n = {x: -.5, y: 1};
        break;
      case"left":
        n = {x: -1, y: 0};
        break;
      case"top-left":
        n = {x: -.5, y: -.5};
        break;
      default:
        n = {x: 0, y: 0}
    }
    i.particles.move.straight ? (this.vx = n.x, this.vy = n.y, i.particles.move.random && (this.vx = this.vx * Math.random(), this.vy = this.vy * Math.random())) : (this.vx = n.x + Math.random() - .5, this.vy = n.y + Math.random() - .5), this.vx_i = this.vx, this.vy_i = this.vy;
    var r = i.particles.shape.type;
    if ("object" == typeof r) {
      if (r instanceof Array) {
        var c = r[Math.floor(Math.random() * r.length)];
        this.shape = c
      }
    } else this.shape = r;
    if ("image" == this.shape) {
      var o = i.particles.shape;
      this.img = {
        src: o.image.src,
        ratio: o.image.width / o.image.height
      }, this.img.ratio || (this.img.ratio = 1), "svg" == i.tmp.img_type && void 0 != i.tmp.source_svg && (i.fn.vendors.createSvgImg(this), i.tmp.pushing && (this.img.loaded = !1))
    }
  }, i.fn.particle.prototype.draw = function () {
    function e() {
      i.canvas.ctx.drawImage(r, a.x - t, a.y - t, 2 * t, 2 * t / a.img.ratio)
    }

    var a = this;
    if (void 0 != a.radius_bubble)var t = a.radius_bubble; else var t = a.radius;
    if (void 0 != a.opacity_bubble)var s = a.opacity_bubble; else var s = a.opacity;
    if (a.color.rgb)var n = "rgba(" + a.color.rgb.r + "," + a.color.rgb.g + "," + a.color.rgb.b + "," + s + ")"; else var n = "hsla(" + a.color.hsl.h + "," + a.color.hsl.s + "%," + a.color.hsl.l + "%," + s + ")";
    switch (i.canvas.ctx.fillStyle = n, i.canvas.ctx.beginPath(), a.shape) {
      case"circle":
        i.canvas.ctx.arc(a.x, a.y, t, 0, 2 * Math.PI, !1);
        break;
      case"edge":
        i.canvas.ctx.rect(a.x - t, a.y - t, 2 * t, 2 * t);
        break;
      case"triangle":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t, a.y + t / 1.66, 2 * t, 3, 2);
        break;
      case"polygon":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t / (i.particles.shape.polygon.nb_sides / 3.5), a.y - t / .76, 2.66 * t / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 1);
        break;
      case"star":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - 2 * t / (i.particles.shape.polygon.nb_sides / 4), a.y - t / 1.52, 2 * t * 2.66 / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 2);
        break;
      case"image":
        if ("svg" == i.tmp.img_type)var r = a.img.obj; else var r = i.tmp.img_obj;
        r && e()
    }
    i.canvas.ctx.closePath(), i.particles.shape.stroke.width > 0 && (i.canvas.ctx.strokeStyle = i.particles.shape.stroke.color, i.canvas.ctx.lineWidth = i.particles.shape.stroke.width, i.canvas.ctx.stroke()), i.canvas.ctx.fill()
  }, i.fn.particlesCreate = function () {
    for (var e = 0; e < i.particles.number.value; e++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value))
  }, i.fn.particlesUpdate = function () {
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      if (i.particles.move.enable) {
        var t = i.particles.move.speed / 2;
        a.x += a.vx * t, a.y += a.vy * t
      }
      if (i.particles.opacity.anim.enable && (1 == a.opacity_status ? (a.opacity >= i.particles.opacity.value && (a.opacity_status = !1), a.opacity += a.vo) : (a.opacity <= i.particles.opacity.anim.opacity_min && (a.opacity_status = !0), a.opacity -= a.vo), a.opacity < 0 && (a.opacity = 0)), i.particles.size.anim.enable && (1 == a.size_status ? (a.radius >= i.particles.size.value && (a.size_status = !1), a.radius += a.vs) : (a.radius <= i.particles.size.anim.size_min && (a.size_status = !0), a.radius -= a.vs), a.radius < 0 && (a.radius = 0)), "bounce" == i.particles.move.out_mode)var s = {
        x_left: a.radius,
        x_right: i.canvas.w,
        y_top: a.radius,
        y_bottom: i.canvas.h
      }; else var s = {
        x_left: -a.radius,
        x_right: i.canvas.w + a.radius,
        y_top: -a.radius,
        y_bottom: i.canvas.h + a.radius
      };
      switch (a.x - a.radius > i.canvas.w ? (a.x = s.x_left, a.y = Math.random() * i.canvas.h) : a.x + a.radius < 0 && (a.x = s.x_right, a.y = Math.random() * i.canvas.h), a.y - a.radius > i.canvas.h ? (a.y = s.y_top, a.x = Math.random() * i.canvas.w) : a.y + a.radius < 0 && (a.y = s.y_bottom, a.x = Math.random() * i.canvas.w), i.particles.move.out_mode) {
        case"bounce":
          a.x + a.radius > i.canvas.w ? a.vx = -a.vx : a.x - a.radius < 0 && (a.vx = -a.vx), a.y + a.radius > i.canvas.h ? a.vy = -a.vy : a.y - a.radius < 0 && (a.vy = -a.vy)
      }
      if (isInArray("grab", i.interactivity.events.onhover.mode) && i.fn.modes.grabParticle(a), (isInArray("bubble", i.interactivity.events.onhover.mode) || isInArray("bubble", i.interactivity.events.onclick.mode)) && i.fn.modes.bubbleParticle(a), (isInArray("repulse", i.interactivity.events.onhover.mode) || isInArray("repulse", i.interactivity.events.onclick.mode)) && i.fn.modes.repulseParticle(a), i.particles.line_linked.enable || i.particles.move.attract.enable)for (var n = e + 1; n < i.particles.array.length; n++) {
        var r = i.particles.array[n];
        i.particles.line_linked.enable && i.fn.interact.linkParticles(a, r), i.particles.move.attract.enable && i.fn.interact.attractParticles(a, r), i.particles.move.bounce && i.fn.interact.bounceParticles(a, r)
      }
    }
  }, i.fn.particlesDraw = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h), i.fn.particlesUpdate();
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      a.draw()
    }
  }, i.fn.particlesEmpty = function () {
    i.particles.array = []
  }, i.fn.particlesRefresh = function () {
    cancelRequestAnimFrame(i.fn.checkAnimFrame), cancelRequestAnimFrame(i.fn.drawAnimFrame), i.tmp.source_svg = void 0, i.tmp.img_obj = void 0, i.tmp.count_svg = 0, i.fn.particlesEmpty(), i.fn.canvasClear(), i.fn.vendors.start()
  }, i.fn.interact.linkParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = i.particles.line_linked.opacity - n / (1 / i.particles.line_linked.opacity) / i.particles.line_linked.distance;
      if (r > 0) {
        var c = i.particles.line_linked.color_rgb_line;
        i.canvas.ctx.strokeStyle = "rgba(" + c.r + "," + c.g + "," + c.b + "," + r + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(a.x, a.y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
      }
    }
  }, i.fn.interact.attractParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = t / (1e3 * i.particles.move.attract.rotateX), c = s / (1e3 * i.particles.move.attract.rotateY);
      e.vx -= r, e.vy -= c, a.vx += r, a.vy += c
    }
  }, i.fn.interact.bounceParticles = function (e, a) {
    var t = e.x - a.x, i = e.y - a.y, s = Math.sqrt(t * t + i * i), n = e.radius + a.radius;
    n >= s && (e.vx = -e.vx, e.vy = -e.vy, a.vx = -a.vx, a.vy = -a.vy)
  }, i.fn.modes.pushParticles = function (e, a) {
    i.tmp.pushing = !0;
    for (var t = 0; e > t; t++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value, {
      x: a ? a.pos_x : Math.random() * i.canvas.w,
      y: a ? a.pos_y : Math.random() * i.canvas.h
    })), t == e - 1 && (i.particles.move.enable || i.fn.particlesDraw(), i.tmp.pushing = !1)
  }, i.fn.modes.removeParticles = function (e) {
    i.particles.array.splice(0, e), i.particles.move.enable || i.fn.particlesDraw()
  }, i.fn.modes.bubbleParticle = function (e) {
    function a() {
      e.opacity_bubble = e.opacity, e.radius_bubble = e.radius
    }

    function t(a, t, s, n, c) {
      if (a != t)if (i.tmp.bubble_duration_end) {
        if (void 0 != s) {
          var o = n - p * (n - a) / i.interactivity.modes.bubble.duration, l = a - o;
          d = a + l, "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else if (r <= i.interactivity.modes.bubble.distance) {
        if (void 0 != s)var v = s; else var v = n;
        if (v != a) {
          var d = n - p * (n - a) / i.interactivity.modes.bubble.duration;
          "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else"size" == c && (e.radius_bubble = void 0), "opacity" == c && (e.opacity_bubble = void 0)
    }

    if (i.interactivity.events.onhover.enable && isInArray("bubble", i.interactivity.events.onhover.mode)) {
      var s = e.x - i.interactivity.mouse.pos_x, n = e.y - i.interactivity.mouse.pos_y, r = Math.sqrt(s * s + n * n), c = 1 - r / i.interactivity.modes.bubble.distance;
      if (r <= i.interactivity.modes.bubble.distance) {
        if (c >= 0 && "mousemove" == i.interactivity.status) {
          if (i.interactivity.modes.bubble.size != i.particles.size.value)if (i.interactivity.modes.bubble.size > i.particles.size.value) {
            var o = e.radius + i.interactivity.modes.bubble.size * c;
            o >= 0 && (e.radius_bubble = o)
          } else {
            var l = e.radius - i.interactivity.modes.bubble.size, o = e.radius - l * c;
            o > 0 ? e.radius_bubble = o : e.radius_bubble = 0
          }
          if (i.interactivity.modes.bubble.opacity != i.particles.opacity.value)if (i.interactivity.modes.bubble.opacity > i.particles.opacity.value) {
            var v = i.interactivity.modes.bubble.opacity * c;
            v > e.opacity && v <= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          } else {
            var v = e.opacity - (i.particles.opacity.value - i.interactivity.modes.bubble.opacity) * c;
            v < e.opacity && v >= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          }
        }
      } else a();
      "mouseleave" == i.interactivity.status && a()
    } else if (i.interactivity.events.onclick.enable && isInArray("bubble", i.interactivity.events.onclick.mode)) {
      if (i.tmp.bubble_clicking) {
        var s = e.x - i.interactivity.mouse.click_pos_x, n = e.y - i.interactivity.mouse.click_pos_y, r = Math.sqrt(s * s + n * n), p = ((new Date).getTime() - i.interactivity.mouse.click_time) / 1e3;
        p > i.interactivity.modes.bubble.duration && (i.tmp.bubble_duration_end = !0), p > 2 * i.interactivity.modes.bubble.duration && (i.tmp.bubble_clicking = !1, i.tmp.bubble_duration_end = !1)
      }
      i.tmp.bubble_clicking && (t(i.interactivity.modes.bubble.size, i.particles.size.value, e.radius_bubble, e.radius, "size"), t(i.interactivity.modes.bubble.opacity, i.particles.opacity.value, e.opacity_bubble, e.opacity, "opacity"))
    }
  }, i.fn.modes.repulseParticle = function (e) {
    function a() {
      var a = Math.atan2(d, p);
      if (e.vx = u * Math.cos(a), e.vy = u * Math.sin(a), "bounce" == i.particles.move.out_mode) {
        var t = {x: e.x + e.vx, y: e.y + e.vy};
        t.x + e.radius > i.canvas.w ? e.vx = -e.vx : t.x - e.radius < 0 && (e.vx = -e.vx), t.y + e.radius > i.canvas.h ? e.vy = -e.vy : t.y - e.radius < 0 && (e.vy = -e.vy)
      }
    }

    if (i.interactivity.events.onhover.enable && isInArray("repulse", i.interactivity.events.onhover.mode) && "mousemove" == i.interactivity.status) {
      var t = e.x - i.interactivity.mouse.pos_x, s = e.y - i.interactivity.mouse.pos_y, n = Math.sqrt(t * t + s * s), r = {
        x: t / n,
        y: s / n
      }, c = i.interactivity.modes.repulse.distance, o = 100, l = clamp(1 / c * (-1 * Math.pow(n / c, 2) + 1) * c * o, 0, 50), v = {
        x: e.x + r.x * l,
        y: e.y + r.y * l
      };
      "bounce" == i.particles.move.out_mode ? (v.x - e.radius > 0 && v.x + e.radius < i.canvas.w && (e.x = v.x), v.y - e.radius > 0 && v.y + e.radius < i.canvas.h && (e.y = v.y)) : (e.x = v.x, e.y = v.y)
    } else if (i.interactivity.events.onclick.enable && isInArray("repulse", i.interactivity.events.onclick.mode))if (i.tmp.repulse_finish || (i.tmp.repulse_count++, i.tmp.repulse_count == i.particles.array.length && (i.tmp.repulse_finish = !0)), i.tmp.repulse_clicking) {
      var c = Math.pow(i.interactivity.modes.repulse.distance / 6, 3), p = i.interactivity.mouse.click_pos_x - e.x, d = i.interactivity.mouse.click_pos_y - e.y, m = p * p + d * d, u = -c / m * 1;
      c >= m && a()
    } else 0 == i.tmp.repulse_clicking && (e.vx = e.vx_i, e.vy = e.vy_i)
  }, i.fn.modes.grabParticle = function (e) {
    if (i.interactivity.events.onhover.enable && "mousemove" == i.interactivity.status) {
      var a = e.x - i.interactivity.mouse.pos_x, t = e.y - i.interactivity.mouse.pos_y, s = Math.sqrt(a * a + t * t);
      if (s <= i.interactivity.modes.grab.distance) {
        var n = i.interactivity.modes.grab.line_linked.opacity - s / (1 / i.interactivity.modes.grab.line_linked.opacity) / i.interactivity.modes.grab.distance;
        if (n > 0) {
          var r = i.particles.line_linked.color_rgb_line;
          i.canvas.ctx.strokeStyle = "rgba(" + r.r + "," + r.g + "," + r.b + "," + n + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(i.interactivity.mouse.pos_x, i.interactivity.mouse.pos_y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
        }
      }
    }
  }, i.fn.vendors.eventsListeners = function () {
    "window" == i.interactivity.detect_on ? i.interactivity.el = window : i.interactivity.el = i.canvas.el, (i.interactivity.events.onhover.enable || i.interactivity.events.onclick.enable) && (i.interactivity.el.addEventListener("mousemove", function (e) {
      if (i.interactivity.el == window)var a = e.clientX, t = e.clientY; else var a = e.offsetX || e.clientX, t = e.offsetY || e.clientY;
      i.interactivity.mouse.pos_x = a, i.interactivity.mouse.pos_y = t, i.tmp.retina && (i.interactivity.mouse.pos_x *= i.canvas.pxratio, i.interactivity.mouse.pos_y *= i.canvas.pxratio), i.interactivity.status = "mousemove"
    }), i.interactivity.el.addEventListener("mouseleave", function (e) {
      i.interactivity.mouse.pos_x = null, i.interactivity.mouse.pos_y = null, i.interactivity.status = "mouseleave"
    })), i.interactivity.events.onclick.enable && i.interactivity.el.addEventListener("click", function () {
      if (i.interactivity.mouse.click_pos_x = i.interactivity.mouse.pos_x, i.interactivity.mouse.click_pos_y = i.interactivity.mouse.pos_y, i.interactivity.mouse.click_time = (new Date).getTime(), i.interactivity.events.onclick.enable)switch (i.interactivity.events.onclick.mode) {
        case"push":
          i.particles.move.enable ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : 1 == i.interactivity.modes.push.particles_nb ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : i.interactivity.modes.push.particles_nb > 1 && i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb);
          break;
        case"remove":
          i.fn.modes.removeParticles(i.interactivity.modes.remove.particles_nb);
          break;
        case"bubble":
          i.tmp.bubble_clicking = !0;
          break;
        case"repulse":
          i.tmp.repulse_clicking = !0, i.tmp.repulse_count = 0, i.tmp.repulse_finish = !1, setTimeout(function () {
            i.tmp.repulse_clicking = !1
          }, 1e3 * i.interactivity.modes.repulse.duration)
      }
    })
  }, i.fn.vendors.densityAutoParticles = function () {
    if (i.particles.number.density.enable) {
      var e = i.canvas.el.width * i.canvas.el.height / 1e3;
      i.tmp.retina && (e /= 2 * i.canvas.pxratio);
      var a = e * i.particles.number.value / i.particles.number.density.value_area, t = i.particles.array.length - a;
      0 > t ? i.fn.modes.pushParticles(Math.abs(t)) : i.fn.modes.removeParticles(t)
    }
  }, i.fn.vendors.checkOverlap = function (e, a) {
    for (var t = 0; t < i.particles.array.length; t++) {
      var s = i.particles.array[t], n = e.x - s.x, r = e.y - s.y, c = Math.sqrt(n * n + r * r);
      c <= e.radius + s.radius && (e.x = a ? a.x : Math.random() * i.canvas.w, e.y = a ? a.y : Math.random() * i.canvas.h, i.fn.vendors.checkOverlap(e))
    }
  }, i.fn.vendors.createSvgImg = function (e) {
    var a = i.tmp.source_svg, t = /#([0-9A-F]{3,6})/gi, s = a.replace(t, function (a, t, i, s) {
      if (e.color.rgb)var n = "rgba(" + e.color.rgb.r + "," + e.color.rgb.g + "," + e.color.rgb.b + "," + e.opacity + ")"; else var n = "hsla(" + e.color.hsl.h + "," + e.color.hsl.s + "%," + e.color.hsl.l + "%," + e.opacity + ")";
      return n
    }), n = new Blob([s], {type: "image/svg+xml;charset=utf-8"}), r = window.URL || window.webkitURL || window, c = r.createObjectURL(n), o = new Image;
    o.addEventListener("load", function () {
      e.img.obj = o, e.img.loaded = !0, r.revokeObjectURL(c), i.tmp.count_svg++
    }), o.src = c
  }, i.fn.vendors.destroypJS = function () {
    cancelAnimationFrame(i.fn.drawAnimFrame), t.remove(), pJSDom = null
  }, i.fn.vendors.drawShape = function (e, a, t, i, s, n) {
    var r = s * n, c = s / n, o = 180 * (c - 2) / c, l = Math.PI - Math.PI * o / 180;
    e.save(), e.beginPath(), e.translate(a, t), e.moveTo(0, 0);
    for (var v = 0; r > v; v++)e.lineTo(i, 0), e.translate(i, 0), e.rotate(l);
    e.fill(), e.restore()
  }, i.fn.vendors.exportImg = function () {
    window.open(i.canvas.el.toDataURL("image/png"), "_blank")
  }, i.fn.vendors.loadImg = function (e) {
    if (i.tmp.img_error = void 0, "" != i.particles.shape.image.src)if ("svg" == e) {
      var a = new XMLHttpRequest;
      a.open("GET", i.particles.shape.image.src), a.onreadystatechange = function (e) {
        4 == a.readyState && (200 == a.status ? (i.tmp.source_svg = e.currentTarget.response, i.fn.vendors.checkBeforeDraw()) : (console.log("Error pJS - Image not found"), i.tmp.img_error = !0))
      }, a.send()
    } else {
      var t = new Image;
      t.addEventListener("load", function () {
        i.tmp.img_obj = t, i.fn.vendors.checkBeforeDraw()
      }), t.src = i.particles.shape.image.src
    } else console.log("Error pJS - No image.src"), i.tmp.img_error = !0
  }, i.fn.vendors.draw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type ? i.tmp.count_svg >= i.particles.number.value ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : void 0 != i.tmp.img_obj ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame))
  }, i.fn.vendors.checkBeforeDraw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type && void 0 == i.tmp.source_svg ? i.tmp.checkAnimFrame = requestAnimFrame(check) : (cancelRequestAnimFrame(i.tmp.checkAnimFrame), i.tmp.img_error || (i.fn.vendors.init(), i.fn.vendors.draw())) : (i.fn.vendors.init(), i.fn.vendors.draw())
  }, i.fn.vendors.init = function () {
    i.fn.retinaInit(), i.fn.canvasInit(), i.fn.canvasSize(), i.fn.canvasPaint(), i.fn.particlesCreate(), i.fn.vendors.densityAutoParticles(), i.particles.line_linked.color_rgb_line = hexToRgb(i.particles.line_linked.color)
  }, i.fn.vendors.start = function () {
    isInArray("image", i.particles.shape.type) ? (i.tmp.img_type = i.particles.shape.image.src.substr(i.particles.shape.image.src.length - 3), i.fn.vendors.loadImg(i.tmp.img_type)) : i.fn.vendors.checkBeforeDraw()
  }, i.fn.vendors.eventsListeners(), i.fn.vendors.start()
};
Object.deepExtend = function (e, a) {
  for (var t in a)a[t] && a[t].constructor && a[t].constructor === Object ? (e[t] = e[t] || {}, arguments.callee(e[t], a[t])) : e[t] = a[t];
  return e
}, window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (e) {
      window.setTimeout(e, 1e3 / 60)
    }
}(), window.cancelRequestAnimFrame = function () {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout
}(), window.pJSDom = [], window.particlesJS = function (e, a) {
  "string" != typeof e && (a = e, e = "particles-js"), e || (e = "particles-js");
  var t = document.getElementById(e), i = "particles-js-canvas-el", s = t.getElementsByClassName(i);
  if (s.length)for (; s.length > 0;)t.removeChild(s[0]);
  var n = document.createElement("canvas");
  n.className = i, n.style.width = "100%", n.style.height = "100%";
  var r = document.getElementById(e).appendChild(n);
  null != r && pJSDom.push(new pJS(e, a))
}, window.particlesJS.load = function (e, a, t) {
  var i = new XMLHttpRequest;
  i.open("GET", a), i.onreadystatechange = function (a) {
    if (4 == i.readyState)if (200 == i.status) {
      var s = JSON.parse(a.currentTarget.response);
      window.particlesJS(e, s), t && t()
    } else console.log("Error pJS - XMLHttpRequest status: " + i.status), console.log("Error pJS - File config not found")
  }, i.send()
};
/**
 * Created by DELL on 18/7/2018.
 */

(function () {
  'use strict';
  angular
    .module('frontendApp')
    //Altura a pantalla completa
    .directive('windowheight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            //console.log('exit')
          }).resize();
        }
      };
    })
    //Carga video
    .directive('myYoutube', function ($sce) {
      return {
        restrict: 'A',
        scope: {code: '='},
        replace: true,
        template: '<div style="width:100%;"><iframe style="overflow:hidden;height:100%;width:100%" width="100%" height="100%" src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
        link: function (scope) {
          //console.log('here');
          scope.$watch('code', function (newVal) {
            if (newVal) {
              scope.url = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + newVal);
            }
          });
        }
      };
    })
    //Iguala altura entre elementos
    .directive('equalheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@',
          full: '=',
        },
        link: function (scope, element) {
          $(window).resize(function () {
            console.log('targetclass',scope.targetclass);
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              var temp = 0;
              for (var i = 0; i < x.length; i++) {
                if (temp < x[i].offsetHeight) {
                  temp = x[i].offsetHeight;
                }
              }
              element.css({minHeight: temp});
            }, 1000);
          }).resize();
        }
      };
    })
    //Altura parametrizable
    .directive('customheight', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '=',
          autoscroll: '=',
          lockscroll:'='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            if (scope.equal) {
              customHeight = scope.equal;
            }
            if (scope.minus) {
              customHeight -= scope.minus;
            }
            if (scope.plus) {
              customHeight += scope.plus;
            }
            if (scope.autoscroll == true) {
              element.css({maxHeight: customHeight});
              element.css({overflowY: 'scroll'});
            }
            element.css({minHeight: customHeight});
            if(scope.lockscroll==true){
              element.css({maxHeight: customHeight});
              element.css({overflow: 'hidden'});
            }
          }).resize();
        }
      };
    })
    //Detecta cambios en scroll
    .directive('scroll', function () {
      return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
          elem.on('scroll', function (e) {
            console.log('detecta')
          });
        }
      };
    })
})();

'use strict';
angular
  .module('frontendApp')
  .controller('MapsController', function ($state, $log, $rootScope, $scope, $timeout, toastr, ContentService) {
    var vm = this;
    $log.debug('MapsController');

    /****** UI FILTERS ******/
    $rootScope.mapConfig = {
      center: [-16.4909012, -68.1209269],
      context: {
        creator: {
          layer: {
            centroid: false,
            polygon: true,
            label: false
          }
        }
      },
      layer: {
        centroid: false,
        polygon: true,
        label: false
      }
    };

    /****** PARAMS *****/
    vm.poly = {
      a: -16.37398,
      b: -68.30103,
      c: -16.6564,
      d: -67.99822,
      size: 6,
      center: [-16.4909012, -68.1209269],
      layer: {
        centroid: false,
        polygon: true,
        label: false
      }
    };

    /****** POLYGONS *****/
    vm.generatePoints = function () {
      vm.area = {
        center: [-16.4909012, -68.1209269],
        ne: [vm.poly.a, vm.poly.b],
        nw: [vm.poly.a, vm.poly.d],
        sw: [vm.poly.c, vm.poly.d],
        se: [vm.poly.c, vm.poly.b],
        points: [],
        polygons: []
      };
      var d1 = vm.distance(vm.area.ne, vm.area.nw);
      var d1Steps = d1 / vm.poly.size;
      var d2 = vm.distance(vm.area.ne, vm.area.se);
      var d2Steps = d2 / vm.poly.size;
      //POINTS
      for (var j = 0; j < vm.poly.size; j++) {
        var temp = [];
        for (var i = vm.poly.size; i > 0; i--) {
          temp.push([
            vm.area.ne[0] + j * (d1Steps) * -1,
            vm.area.sw[1] + i * (d2Steps) * -1
          ]);
        }
        vm.area.points = vm.area.points.concat(temp);
        console.log('element contrsuido', vm.area.points)
      }
      //POLYGONS
      for (var row = 0; row < vm.poly.size - 1; row++) {
        var min = row * vm.poly.size;
        var max = row * vm.poly.size + vm.poly.size - 1;
        for (var k = 0; k < vm.area.points.length; k++) {
          if (k >= min && k < max) {
            var temp2 = [
              vm.area.points[k],
              vm.area.points[k + 1],
              vm.area.points[k + vm.poly.size + 1],
              vm.area.points[k + vm.poly.size]
            ];
            vm.area.polygons.push(temp2)
          }
        }
      }
      $log.log('POLYGONS', vm.area.polygons)
    };

    vm.getIntersection = function (poly) {
      //      console.log('get intersection', poly);
      var x = (parseFloat(poly[0][0]) + parseFloat(poly[2][0])) / 2;
      var y = (parseFloat(poly[1][1]) + parseFloat(poly[3][1])) / 2;
      //      console.log('get intersection', x, y);
      return [x, y]
    };

    vm.distance = function (a, b) {
      var d = Math.sqrt(Math.pow((a[0] - b[0]), 2) + Math.pow((a[1] - b[1]), 2));
      return d;
    };

    function deg2rad(deg) {
      return deg * (Math.PI / 180);
    }

    vm.getDistanceFromLatLonInKm = function (lat1, lon1, lat2, lon2) {
      var R = 6371; // Radius of the earth in km
      var dLat = deg2rad(lat2 - lat1);  // deg2rad below
      var dLon = deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d;
    }

    $rootScope.polygonFilters = {
      filters: {
        alias: { value: '' },
        year: { value: '' },
        delito_fix: { value: '' },
        delito_macro: { value: '' }
      },
      per_page: 3481,
      page: 1,
      heat: {
        rangeMin: 1,
        rangeMax: 100,
        heatMap: '1'
      }
    };

    $rootScope.getCrimeData = function () {
      $rootScope.polArray = [];
      $rootScope.polygonselected = null;
      ContentService.getdata('polygon', $rootScope.polygonFilters)
        .success(function (res) {
          $log.log('Exit getdata', res);
          vm.polygonRes = res.result.data;
          angular.forEach(vm.polygonRes, function (i) {
            $rootScope.polArray.push({
              id: i.id,
              alias: i.alias,
              active: i.totaltemp,
              status: i.status,
              picked: false,
              shape: [
                JSON.parse(i.northwest),
                JSON.parse(i.southwest),
                JSON.parse(i.southeast),
                JSON.parse(i.northeast)
              ]
            });
          })
          $rootScope.heathMap();
          $timeout(function () {
            $rootScope.ready = true;
          }, 2000)
        });
      /*ContentService.update(
        'mbi',
        1070,
        {
        POLYGON_ID: 1
      })
        .success(function (res) {
          $log.log('Exit update', res);
        });*/
      // https://maps.googleapis.com/maps/api/place/findplacefromtext/json?
      // input=Museum%20of%20Contemporary%20Art%20Australia&
      // inputtype=textquery
      // &fields=photos,formatted_address,name,rating,opening_hours,geometry
      // &key=YOUR_API_KEY

      // ContentService.finPlace()
    };


    $rootScope.findPlace = function (id) {
      ContentService.find('mbi', id)
        .success(function (res) {
          $log.log('Exit find', res);
          var params = {
            key: 'AIzaSyDQpsAhUfD7vh_PH_6o0PvEKC0aBZnrll8',
            input: encodeURI('' + res.MUNICIPIOS + ' ' + res.ZONA_BARRIO + ' ' + res.AVENIDA_CALLE),
            inputtype: encodeURI('textquery')
          };
          ContentService.finPlace(params)
            .then(function (res2) {
              $log.log('salida maps', res2)
            })
        });
    }

    vm.older = null;
    $rootScope.printFromMap = function (event, poly, autoexecute) {
      //setOptions({ fillColor: '#0000ff' });
      console.log('printFromMap', poly, this);
      $rootScope.polySelected = poly;
      $rootScope.polyBackup = angular.copy($rootScope.polySelected);

      if(autoexecute===true){
        $rootScope.polySelected.status = !$rootScope.polySelected.status ;
        $rootScope.polyBackup = angular.copy($rootScope.polySelected);
      }
    };


    $rootScope.polygonAutoChange = function (poly){
      //ng-right-click
      console.log('áuto change',poly);
    }

    $rootScope.updatePolygon = function (action) {
      if (action === true) {
        var params = {
          id: $rootScope.polySelected.id,
          status: $rootScope.polySelected.status
        }
        console.log('actualizando', action, $rootScope.polySelected, params)
         ContentService.update('polygon', $rootScope.polySelected.id,  params)
           .success(function (res) {
             $log.log('Exit update', res);
           })
      }
      else {
        $rootScope.polySelected = angular.copy($rootScope.polyBackup);

      }
    }

    $rootScope.gethospitals = function () {
      ContentService.getdata('environments', {
        filters: {
          type: {
            value: 'clinic',
            operator: 'like'
          }
        },
        orderBy: {
          field: 'id',
          direction: 'asc'
        },
        per_page: 5
      }).success(function (res) {
        $log.log('Exit getdata', res);
        $rootScope.hospitals = res.result.data;
        angular.forEach($rootScope.hospitals, function (i) {
          i.gps = $rootScope.fixGPS(i.coordinates);
        });
        console.log('hospitals', $rootScope.hospitals)
        $timeout(function () {
          $rootScope.ready = true;
        }, 2000)
      });
    };

    $rootScope.fixGPS = function (value) {
      var gps = value.split("-");
      return [parseFloat(gps[1]) * -1, parseFloat(gps[2]) * -1]
    }

    function fRGB(value) {
      var range = $rootScope.polygonFilters.heat.heatMap === '1' ?
        $rootScope.polygonFilters.heat.rangeMax : 1;
      var level = value > range ? range : value;
      return {
        r: Math.round(level * (255 / range)),
        g: Math.round(255 - level * (255 / range)),
        b: 0
      };
    }
    function componentToHex(c) {
      var hex = c.toString(16);
      return hex.length == 1 ? "0" + hex : hex;
    }
    function rgbToHex(obj) {
      return "#" + componentToHex(obj.r) + componentToHex(obj.g) + componentToHex(obj.b);
    }
    $rootScope.getColor = function (value) {
      return rgbToHex(fRGB(value));
    }
    $rootScope.heathMap = function () {
      var temp = angular.copy($rootScope.polArray);
      $rootScope.polArray = [];
      angular.forEach(temp, function (i) {
        i.rgb = fRGB(i.active);
        i.color = rgbToHex(i.rgb);
        $rootScope.polArray.push(i)
        //i.color = $rootScope.getColor(i.active);
      });
      console.log('mapa cargado', $rootScope.polArray);
    }

  })
  .directive('ngRightClick', function($parse) {
    return function(scope, element, attrs) {
        var fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function(event) {
            scope.$apply(function() {
                event.preventDefault();
                fn(scope, {$event:event});
            });
        });
    };
})

  //A1430
  ;

'use strict';
angular
  .module('frontendApp')
  .controller('AppController', function ($state, $log, $rootScope, $scope, $timeout, toastr,
                                         ContentService) {
    var vm = this;
    $log.debug('AppController');

    /*************** APP MENU **************/
    $rootScope.menu = false;
    $rootScope.showMenu = function (value) {
      $rootScope.menu = (value) ? value : !$rootScope.menu;
    };
    $rootScope.$watch('menu', function () {
      if ($rootScope.menu == true) {
        document.body.style.overflow = 'hidden';
      }
      else {
        document.body.style.overflow = 'initial';
      }
    });

    /********  MODALS AND WEB FORMS ********/
    $rootScope.modals = {
      currentModal: ''
    };
    $rootScope.showModal = function (modal, value) {
      $log.log(modal);
      $rootScope.currentModal = modal;
      $rootScope.modals.currentModal = 'app/views/modals/' + modal + '.html';
      $rootScope.modalTab = 1;
      $rootScope.formData = {};
      $rootScope.validateRequest();
    };
    $rootScope.formDataHome = {};
    $rootScope.closeModal = function () {
      $rootScope.modals.currentModal = '';
      $rootScope.modalTab = 1;
    };
    $rootScope.$watch('modals', function () {
      if ($rootScope.modals.currentModal != '') {
        document.body.style.overflow = 'hidden';
      }
      else {
        document.body.style.overflow = 'initial';
      }
    }, true);
    //recaptcha
    function onloadCallback() {
      /*grecaptcha.ready(function () {
        grecaptcha.execute('6LfvLrgUAAAAAKwr9FHjRABHKfH6oLyQ6bzMldo0', {action: 'contact'})
          .then(function (token) {
            //$log.log('CAPTCHA', token);
            $rootScope.gc = token;
          });
      });*/
    }
    $rootScope.validateRequest = function () {
      onloadCallback();
    };
    $rootScope.sendForm = function (id, data, flash) {
      if (id && data) {
        var params = {
          mailingcategory_id: id,
          gc: $rootScope.gc,
          fields: data
        };
        ContentService.sendform(params)
          .success(function (res) {
            if (res.status) {
              $rootScope.navModals('next');
            }
            else {
              toastr.warning('Please try again', 'Connection error');
            }
          });
      }
      else {
        $rootScope.navModals('next');
      }
      if (flash) {
        toastr.success($rootScope.sT('Mensaje enviado', 'Message sent'), 'Success');
      }
    };

    /******** OTHER CONFIGURATIONS *********/
    //OWL CAROUSELL DEFAULT CONFIGURATION
    $rootScope.defaultOwlConf = {
      items: 1,
      nav: true,
      // startPosition:parseInt(index),
      loop: true,
      autoplay: false,
      autoPlaySpeed: 5000,
      autoPlayTimeout: 5000,
      autoplayHoverPause: true,
      navText: ['<span><i class="fas fa-chevron-up"></i></span>', '<span><i class="fas fa-chevron-down"></i></span>'],
    };
    //COPY TO CLIPBOARD
    $rootScope.copyToShare = function (id) {
      var copyText = document.getElementById(id);
      copyText.select();
      document.execCommand("copy");
      var a = copyText.value;
      var split = a.slice(0, 30);
      toastr.success(split + '..', 'Copied');
    };
    //MONTHS
    $rootScope.momths = [
      {value: '1', label: {es: 'Enero', en: 'January'}},
      {value: '2', label: {es: 'Febrero', en: 'Febrary'}},
      {value: '3', label: {es: 'Marzo', en: 'March'}},
      {value: '4', label: {es: 'Abril', en: 'April'}},
      {value: '5', label: {es: 'Mayo', en: 'May'}},
      {value: '6', label: {es: 'Junio', en: 'June'}},
      {value: '7', label: {es: 'Julio', en: 'July'}},
      {value: '8', label: {es: 'Agosto', en: 'August'}},
      {value: '9', label: {es: 'Septiembre', en: 'September'}},
      {value: '10', label: {es: 'Octubre', en: 'October'}},
      {value: '11', label: {es: 'Noviembre', en: 'November'}},
      {value: '12', label: {es: 'Diciembre', en: 'December'}},
    ];
    //MAIL TO
    $rootScope.sendMail = function (emailId, subject, message) {
      $window.open("mailto:" + emailId + "?subject=" + subject + "&body=" + message, "_self");
    };
    //STRINGS TO URL
    $rootScope.encodeName = function (value) {
      return encodeURI(value);
    };

    /******** MAPS FUNCTIONS *********/
    $rootScope.MapsStyle = [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#212121"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#212121"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#181818"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#1b1b1b"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#2c2c2c"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#8a8a8a"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#373737"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#3c3c3c"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#4e4e4e"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#000000"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#3d3d3d"
          }
        ]
      }
    ];







  });

(function() {
  'use strict';

  angular
      .module('frontendApp')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1516719002839;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontendApp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, ContentService,
    ImageLoader,
    $anchorScroll, $location,
    localStorageService, $timeout, $window, $stateParams) {

    /***** REST API ROUTE *******/
    //$rootScope.api = 'http://localhost:8000';
    $rootScope.api = 'http://crime-prediction.aknatechnologies.com/restapi/public';

    /**** SESSION VARS FUNCTIONS ****/
    $rootScope.getSessionParam = function (key) {
      return localStorageService.get(key);
    };
    $rootScope.setSessionParam = function (key, val) {
      return localStorageService.set(key, val);
    };
    /***** LANGUAGE FUNCTIONS *****/
    //VERIFY CURRENT LANGUAGE
    $timeout(function () {
      if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
        $rootScope.changeLanguage($stateParams.lan, $rootScope.currentState);
      }
      else {
        $rootScope.language = 'es';
      }
    }, 2);
    //TRANSALATE
    $rootScope.transl = function (target) {
      if (target) {
        return target[$rootScope.language];
      }
      else {
        return '';
      }
    };
    //select count(*) as total, polygon_alias from crime_v3 GROUP by polygon_alias order by total desc;
    //CHANGE OF ROUTE SETTING A NEW LANGUAGE
    $rootScope.changeLanguage = function (value, state) {
      $rootScope.language = value;
      $rootScope.setSessionParam('language', value);
      $state.go(state, { lan: value });
      delete $rootScope.wc;
    };

    /********* ROUTE CHANGES ******/
    $rootScope.stateGo = function (state, params, reload) {
      $state.go(state, params, reload);
      $rootScope.showLoader = true;
      // $rootScope.scroller(sec);
    };
    //AUTO EXECUTE ON ROUTE CHANGE OR LOAD
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      $log.log('$stateChangeSuccess', $stateParams);
      $state.current = toState;
      $rootScope.$state = $state;
      $rootScope.menu = false;
      $rootScope.showLoader = false;
      $rootScope.currentState = $state.current.name;
      $rootScope.currentURL = $window.location.href;
      $rootScope.closeModal();
      //RESTAPI CONTENTS
      $rootScope.wc = {}
    });






  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/home');
    $stateProvider

      .state('home', {
        url: '/:lan',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/main.html',
        controller: 'MapsController',
        controllerAs: 'maps'
      });


    $urlRouterProvider.otherwise('/es');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frontendApp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider, $authProvider, localStorageServiceProvider) {
    /*// Set the default quality
    $colorThiefProvider.setDefaultQuality(50);

    // Set the default palette color count
    $colorThiefProvider.setDefaultColorCount(5);

    // Set wether to return arrays (ColorThief's default) or
    // objects like {r: 242, g: 124, b: 91} (false by default).
    $colorThiefProvider.setReturnObjects(true);*/

    // Login
    $authProvider.loginUrl = 'http://localhost:8000/api/authenticate';
    localStorageServiceProvider
      .setPrefix('adminApp')
      .setStorageType('sessionStorage')
      .setNotify(true, true);

    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('#');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    //toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-bottom-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
    new WOW().init();
  }

})();

angular.module("frontendApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/views/header.html","<div class=\"menu-header\"><div class=\"header\"><div class=\"navbar navbar-default\" role=\"navigation\"><img src=\"../assets/images/brand.png\" alt=\"\" class=\"brand\"><div class=\"navbar-header\"></div><ul class=\"nav navbar-nav lan-link\"><li><p><a href=\"\" data-ng-click=\"$root.changeLanguage(\'es\',$root.currentState)\" data-ng-class=\"{\'active\':$root.language==\'es\'}\" class=\"lan\">Es</a> | <a href=\"\" data-ng-click=\"$root.changeLanguage(\'en\',$root.currentState)\" data-ng-class=\"{\'active\':$root.language==\'en\'}\" class=\"lan\">En</a></p></li></ul></div></div></div>");
$templateCache.put("app/views/loader.html","<div windowheight=\"\" class=\"loader-wrapper\"><div loader=\"\" class=\"load up\"><svg class=\"brand\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewbox=\"0 0 704 243.8\" style=\"enable-background:new 0 0 704 243.8;\" xml:space=\"preserve\"><style type=\"text/css\">\n        .st0{fill:#FFFFFF;}\n      </style><g><path class=\"st0\" d=\"M0,45.9h64.5c59.5,0,98.7,35.6,98.7,97c0,61.7-39.1,97.6-98.7,97.6H0V45.9z M62.6,216.8 c43.8,0,72.5-25.9,72.5-73.9c0-47.7-28.9-73.3-72.5-73.3H27.3v147.2H62.6z\"></path><path class=\"st0\" d=\"M290.9,42.6c56.2,0,99.8,43.3,99.8,99.2c0,57.3-43.5,102-99.8,102s-100.1-44.7-100.1-102 C190.9,85.9,234.7,42.6,290.9,42.6 M290.9,218.7c39.7,0,71.7-33.1,71.7-76.9c0-42.4-32-74.4-71.7-74.4s-71.9,32-71.9,74.4 C219,185.6,251.2,218.7,290.9,218.7\"></path><path class=\"st0\" d=\"M420.4,45.9h59.5c20.4,0,28.9,1.7,36.4,4.4c19.8,7.4,32.8,27,32.8,52.6c0,24.8-13.8,45.8-35,52.6v0.6 c0,0,2.2,2.5,5.8,8.8l41.3,75.5h-30.9L489.3,163h-41.6v77.5h-27.3V45.9z M486.8,139.3c21.2,0,34.5-13.5,34.5-35.3 c0-14.3-5.5-24.5-15.4-30c-5.2-2.8-11.6-4.4-26.7-4.4h-31.4v69.7H486.8z\"></path><polygon class=\"st0\" points=\"586.4,45.9 699.4,45.9 699.4,69.6 613.6,69.6 613.6,130.5 683.4,130.5 683.4,154.2 613.6,154.2 613.6,216.8 704,216.8 704,240.5 586.4,240.5\"></polygon><polygon class=\"st0\" points=\"610.9,33.2 681.1,33.2 646,0\"></polygon></g></svg><div class=\"load-bar\"></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/views/modals/modalcontact.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid wow fadeIn\" customheight=\"\" autoscroll=\"true\"><a class=\"close-button\" data-ng-click=\"$root.closeModal()\"><svg width=\"38px\" height=\"39px\" viewbox=\"0 0 38 39\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Home\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Desktop-01\" transform=\"translate(-21.000000, -21.000000)\" fill=\"#F4D956\"><g id=\"cerrar\" transform=\"translate(21.000000, 21.000000)\"><g id=\"Group-2\"><rect id=\"Rectangle-2-Copy\" transform=\"translate(19.000000, 19.500000) rotate(-315.000000) translate(-19.000000, -19.500000)\" x=\"-6\" y=\"18\" width=\"50\" height=\"3\"></rect><rect id=\"Rectangle-2-Copy\" transform=\"translate(19.000000, 19.500000) rotate(-45.000000) translate(-19.000000, -19.500000)\" x=\"-6\" y=\"18\" width=\"50\" height=\"3\"></rect></g></g></g></g></svg></a><div class=\"form-wrapper\"><form ng-submit=\"$root.sendForm(3, $root.formData, true)\"><h3 class=\"form-title\">{{$root.sT(\'Contáctenos\',\'Contact us\')}}</h3><div class=\"input-row\"><input type=\"text\" data-ng-model=\"$root.formData.name\" required=\"\" placeholder=\"{{$root.sT(\'Nombre *\',\'Name *\')}}\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"email\" data-ng-model=\"$root.formData.email\" required=\"\" placeholder=\"{{$root.sT(\'Correo electrónico *\',\'Email *\')}}\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" data-ng-model=\"$root.formData.phone\" placeholder=\"{{$root.sT(\'Teléfono\',\'Phone\')}}\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" data-ng-model=\"$root.formData.enterprise\" placeholder=\"{{$root.sT(\'Empresa\',\'Enterprise\')}}\" class=\"form-control\"></div><div class=\"input-row\"><input type=\"text\" data-ng-model=\"$root.formData.area\" placeholder=\"{{$root.sT(\'Área de interes\',\'Area of ​​interest\')}}\" class=\"form-control\"></div><div class=\"input-row\"><textarea name=\"\" data-ng-model=\"$root.formData.message\" placeholder=\"{{$root.sT(\'Mensaje\',\'Message\')}}\" class=\"form-control\"></textarea></div><div class=\"input-row\"><button style=\"margin-top: 20px; margin: 20px auto; display: block; float: none;\" type=\"submit\" class=\"button button--antiman button--round-l button--text-medium\">{{$root.sT(\'Enviar\',\'Send\')}}</button></div></form></div></div></div>");
$templateCache.put("app/views/maps/polygon-creation.html","<div class=\"row section s3 contact-wrapper\" customheight=\"\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><div windowheight=\"\" class=\"wrapper-body left-box\"><div class=\"article\"><div class=\"content\"><h4>Configuration</h4><form action=\"\"><div class=\"group-form\"><label for=\"\" class=\"form-help\">Map center</label> <input type=\"text\" data-ng-model=\"maps.poly.center\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Matrix Size</label> <input type=\"number\" data-ng-model=\"maps.poly.size\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">North East Lat</label> <input type=\"number\" data-ng-model=\"maps.poly.a\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">North Est Lon</label> <input type=\"number\" data-ng-model=\"maps.poly.b\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">South West Lat</label> <input type=\"number\" data-ng-model=\"maps.poly.c\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">South West Lon</label> <input type=\"number\" data-ng-model=\"maps.poly.d\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Distance between points X</label><p class=\"form-control\">{{maps.getDistanceFromLatLonInKm(maps.area.points[0][0],maps.area.points[0][1],maps.area.points[1][0],maps.area.points[1][1])}}</p></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Distance between points Y</label><p class=\"form-control\">{{maps.getDistanceFromLatLonInKm(maps.area.points[0][0],maps.area.points[0][1],maps.area.points[maps.poly.size][0],maps.area.points[maps.poly.size][1])}}</p></div><div class=\"col-xs-12\"><label for=\"\" class=\"form-help\">Polygons</label> <textarea class=\"form-control\" id=\"points-0\" style=\"height: initial; min-height: 34px; max-height: 100px; overflow-Y: scroll;:\">{{maps.area.polygons}}</textarea></div></form><div class=\"col-xs-12\"><div class=\"social-box\"><a class=\"social pull-right\" target=\"_blank\" data-ng-click=\"maps.generatePoints()\" href=\"\"><i class=\"fas fa-sync\"></i></a> <a class=\"social pull-left\" target=\"_blank\" data-ng-click=\"$root.copyToShare(\'points-0\')\" href=\"\"><i class=\"fas fa-link\"></i></a> <a class=\"social pull-left\" target=\"_blank\" data-ng-class=\"{active:maps.poly.layer.polygon==true && maps.area.polygons.length>0}\" data-ng-click=\"maps.poly.layer.polygon = !maps.poly.layer.polygon\" href=\"\"><i class=\"fas fa-vector-square\"></i></a> <a class=\"social pull-left\" target=\"_blank\" data-ng-class=\"{active:maps.poly.layer.label==true && maps.area.polygons.length>0}\" data-ng-click=\"maps.poly.layer.label = !maps.poly.layer.label\" href=\"\"><i class=\"fas fa-tags\"></i></a> <a class=\"social pull-left\" target=\"_blank\" data-ng-class=\"{active:maps.poly.layer.centroid==true && maps.area.polygons.length>0}\" data-ng-click=\"maps.poly.layer.centroid = !maps.poly.layer.centroid\" href=\"\"><i class=\"fas fa-map-marker-alt\"></i></a></div></div><div class=\"col-xs-12\"><div class=\"group-form\"><label for=\"\" class=\"form-help\">ID crime</label> <input type=\"text\" data-ng-model=\"$root.crimeId\" class=\"form-control\"></div><button data-ng-click=\"$root.findPlace($root.crimeId)\" class=\"btn-success\">Obtain</button></div></div></div></div><div windowheight=\"\" class=\"wrapper-body right-box\"><ng-map windowheight=\"\" center=\"{{maps.poly.center}}\" zoom=\"11\" styles=\"{{$root.MapsStyle}}\"><shape data-ng-if=\"maps.poly.layer.polygon===true\" data-ng-repeat=\"poly in maps.area.polygons\" on-click=\"$root.printFromMap(poly)\" path=\"{{poly}}\" name=\"polygon\"></shape><marker data-ng-if=\"maps.poly.layer.centroid===true\" data-ng-repeat=\"poly in maps.area.polygons\" on-click=\"$root.printFromMap(poly)\" position=\"{{maps.getIntersection(poly)}}\" title=\"Marker\"></marker><custom-marker data-ng-if=\"maps.poly.layer.label===true\" data-ng-repeat=\"poly in maps.area.polygons\" on-click=\"$root.printFromMap(poly)\" position=\"{{maps.getIntersection(poly)}}\">{{$index}}</custom-marker></ng-map></div></div>");
$templateCache.put("app/views/pages/main.html","<div class=\"row section s3 contact-wrapper\" customheight=\"\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><div customheight=\"\" autoscroll=\"true\" class=\"wrapper-body left-box\"><div class=\"article\"><accordion close-others=\"oneAtATime\"><accordion-group class=\"panel-profile\"><accordion-heading is-open=\"true\"><h4>Polygon Generator</h4><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></accordion-heading><div class=\"content\"><form action=\"\"><div class=\"group-form\"><label for=\"\" class=\"form-help\">Map center</label> <input type=\"text\" data-ng-model=\"maps.poly.center\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Matrix Size</label> <input type=\"number\" data-ng-model=\"maps.poly.size\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">North East Lat</label> <input type=\"number\" data-ng-model=\"maps.poly.a\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">North Est Lon</label> <input type=\"number\" data-ng-model=\"maps.poly.b\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">South West Lat</label> <input type=\"number\" data-ng-model=\"maps.poly.c\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">South West Lon</label> <input type=\"number\" data-ng-model=\"maps.poly.d\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Distance X</label><p class=\"form-control\">{{maps.getDistanceFromLatLonInKm(maps.area.points[0][0],maps.area.points[0][1],maps.area.points[1][0],maps.area.points[1][1])}}</p></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Distance Y</label><p class=\"form-control\">{{maps.getDistanceFromLatLonInKm(maps.area.points[0][0],maps.area.points[0][1],maps.area.points[maps.poly.size][0],maps.area.points[maps.poly.size][1])}}</p></div><div class=\"col-xs-12\"><label for=\"\" class=\"form-help\">Polygons</label> <textarea class=\"form-control\" id=\"points-0\" style=\"height: initial; min-height: 34px; max-height: 100px; overflow-Y: scroll;:\">{{maps.area.polygons}}</textarea></div></form></div><div class=\"social-box\"><a class=\"social big pull-right\" target=\"_blank\" data-ng-click=\"maps.generatePoints()\">cargar <i class=\"fas fa-sync\"></i></a> <a class=\"social pull-left\" target=\"_blank\" data-ng-click=\"$root.copyToShare(\'points-0\')\" href=\"\"><i class=\"fas fa-link\"></i></a> <a class=\"social pull-left\" target=\"_blank\" data-ng-class=\"{active:maps.poly.layer.polygon==true && maps.area.polygons.length>0}\" data-ng-click=\"maps.poly.layer.polygon = !maps.poly.layer.polygon\" href=\"\"><i class=\"fas fa-vector-square\"></i></a> <a class=\"social pull-left\" target=\"_blank\" data-ng-class=\"{active:maps.poly.layer.label==true && maps.area.polygons.length>0}\" data-ng-click=\"maps.poly.layer.label = !maps.poly.layer.label\" href=\"\"><i class=\"fas fa-tags\"></i></a> <a class=\"social pull-left\" target=\"_blank\" data-ng-class=\"{active:maps.poly.layer.centroid==true && maps.area.polygons.length>0}\" data-ng-click=\"maps.poly.layer.centroid = !maps.poly.layer.centroid\" href=\"\"><i class=\"fas fa-map-marker-alt\"></i></a></div></accordion-group><accordion-group class=\"panel-profile\"><accordion-heading><h4>Heatmap</h4><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></accordion-heading><div class=\"content\"><form action=\"\"><div class=\"group-form\"><label for=\"\" class=\"form-help\">Rango Min</label> <input type=\"text\" data-ng-model=\"$root.polygonFilters.heat.rangeMin\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Rango Max</label> <input type=\"text\" data-ng-model=\"$root.polygonFilters.heat.rangeMax\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Heat view</label> <input type=\"radio\" ng-value=\"1\" data-ng-model=\"$root.polygonFilters.heat.heatMap\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Simple view</label> <input type=\"radio\" ng-value=\"2\" data-ng-model=\"$root.polygonFilters.heat.heatMap\" class=\"form-control\"></div></form></div><div class=\"social-box\"><a class=\"social big pull-right\" target=\"_blank\" data-ng-click=\"$root.heathMap()\"><i style=\"margin-right: 10px;\" class=\"fas fa-sync\"></i> recargar</a></div></accordion-group><accordion-group class=\"panel-profile\" is-open=\"true\"><accordion-heading><h4>Polygon Service</h4><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></accordion-heading><div class=\"content\"><form action=\"\"><div class=\"group-form\"><label for=\"\" class=\"form-help\">Per Page</label> <input type=\"number\" data-ng-model=\"$root.polygonFilters.per_page\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Page</label> <input type=\"number\" data-ng-model=\"$root.polygonFilters.page\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Polygon Alias</label> <input type=\"text\" data-ng-model=\"$root.polygonFilters.filters.alias.value\" class=\"form-control\"></div></form></div><div class=\"social-box\"><a class=\"social big pull-right\" target=\"_blank\" data-ng-click=\"$root.getCrimeData()\"><i style=\"margin-right: 10px;\" class=\"fas fa-sync\"></i> recargar</a></div></accordion-group></accordion><div class=\"content\"><div class=\"col-xs-12\"><h4>Polygono seleccionado</h4><p><b>Polygon Alias:</b>{{$root.polySelected.alias}}</p><p><b>Recorded crimes:</b>{{$root.polySelected.active}}</p><div class=\"group-form\"><label for=\"\" class=\"form-help\">Enabled</label> <input type=\"radio\" ng-value=\"1\" data-ng-model=\"$root.polySelected.status\" data-ng-change=\"$root.updatePolygon(true)\" class=\"form-control\"></div><div class=\"group-form\"><label for=\"\" class=\"form-help\">Disabled</label> <input type=\"radio\" ng-value=\"0\" data-ng-change=\"$root.updatePolygon(true)\" data-ng-model=\"$root.polySelected.status\" class=\"form-control\"></div></div></div></div></div><div windowheight=\"\" class=\"wrapper-body right-box\"><ng-map windowheight=\"\" center=\"{{maps.poly.center}}\" zoom=\"11\" styles=\"{{$root.MapsStyle}}\"><shape data-ng-if=\"$root.polArray\" data-ng-repeat=\"poly in $root.polArray\" on-click=\"$root.printFromMap(poly)\" path=\"{{poly.shape}}\" name=\"polygon\" fill-color=\'{{(poly.status==\"1\")?poly.color:\"\"}}\' stroke-color=\"{{poly.color}}\" stroke-opacity=\"0.7\" stroke-weight=\"0.5\"></shape><shape data-ng-if=\"maps.poly.layer.polygon===true\" data-ng-repeat=\"poly in maps.area.polygons\" on-click=\"$root.printFromMap(poly)\" path=\"{{poly}}\" name=\"polygon\"></shape><marker data-ng-if=\"maps.poly.layer.centroid===true\" data-ng-repeat=\"poly in maps.area.polygons\" position=\"{{maps.getIntersection(poly)}}\" title=\"Marker\"></marker><custom-marker data-ng-if=\"maps.poly.layer.label===true\" data-ng-repeat=\"poly in maps.area.polygons\" on-click=\"$root.printFromMap(poly)\" position=\"{{maps.getIntersection(poly)}}\">{{$index}}</custom-marker></ng-map></div></div>");}]);